<ng-container *ngIf="ready">
  <ng-container *ngIf="ready">
    <div class="butonera">
      <button type="button" (click)="create()" mat-stroked-button class="btn btn-warning btn-circle btn-lg p-0">
        <mat-icon class="mat-icon-add-custom">add</mat-icon>
      </button>
    </div>

  </ng-container>

  <ng-container>
    <app-table [columns]="headerTable" [dataSource]="dataSource" [hasButton]="true" [actionsTemplate]="actionsButtons">
    </app-table>
  </ng-container>

  <ng-container *ngIf="empty">
    <div class="text-center">
      <img src="assets/icons/factura.svg" class="invoiceImage">
      <p style="color: #9e9e9e">No tiene ningún producto, presione + para crear uno.</p>
    </div>
  </ng-container>



  <ng-template #actionsButtons let-uid="uid">
    <ul class="custom-class">
      <li (click)="edit(uid)">
        <a>
          <mat-icon>create</mat-icon>Editar
        </a>
      </li>
      <li (click)="delete(uid)">
        <a>
          <mat-icon>warning</mat-icon>Borrar
        </a>
      </li>
    </ul>
  </ng-template>

</ng-container>
<ng-container *ngIf="ready === false">
  <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>
